var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEdit = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M17.915 2.085a3.19 3.19 0 0 0-4.513 0L2.426 13.06c-.202.201-.381.38-.522.595a2.5 2.5 0 0 0-.293.607c-.079.244-.106.497-.138.78l-.318 2.863a.85.85 0 0 0 .939.939l2.863-.318c.283-.032.536-.06.78-.138q.324-.105.607-.293c.215-.14.394-.32.595-.522l8.49-8.49.003-.003.002-.002 2.481-2.481a3.19 3.19 0 0 0 0-4.513m-3.31 1.202a1.491 1.491 0 1 1 2.108 2.109l-1.882 1.882-2.11-2.109zM3.671 14.219 11.52 6.37l2.109 2.11-7.848 7.847c-.268.268-.32.315-.372.35a.8.8 0 0 1-.196.093c-.058.02-.128.031-.505.073l-1.746.194.194-1.746c.042-.377.054-.447.073-.505a.8.8 0 0 1 .094-.196c.034-.051.08-.104.349-.372",
  clipRule: "evenodd"
})));
SvgEdit.displayName = "SvgEdit";
export { SvgEdit as ReactComponent };
export default SvgEdit;